// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Display .Display__Options .Display__Options__Row {\n  display: flex;\n  flex-direction: row;\n}\n\n.Display .Display__Options .Display__Options__Row label {\n  display: flex;\n  flex-direction: column-reverse;\n  margin: 0 20px;\n}\n\n.Display__ListItemText {\n  max-width: 75%;\n}\n", ""]);
// Exports
module.exports = exports;
